export var InsightCardType;
(function (InsightCardType) {
    InsightCardType[InsightCardType["CART_ABANDONMENT"] = 1] = "CART_ABANDONMENT";
    InsightCardType[InsightCardType["CROSS_SELL"] = 7] = "CROSS_SELL";
    InsightCardType[InsightCardType["PRODUCT_REPLENISHMENT"] = 11] = "PRODUCT_REPLENISHMENT";
})(InsightCardType || (InsightCardType = {}));
